<div [ngClass]="previewAndCloseOnImage ? 'card border-0 rounded-0' : ''">
  @if (previewAndCloseOnImage) {
    <div class="card-header">
      Tap to Zoom
      <span class="float-end" (click)="onCloseDialogue()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
  }
  @if (previewAndCloseOnImage) {
    <div class="text-center text-body-tertiary mb-2">
      @if (timeStamp) {
        <span>Uploaded at {{ timeStamp | date: "d MMM y HH:mm" }}</span>
      }
    </div>
  }
  <div [ngClass]="previewAndCloseOnImage ? 'image-wrapper' : 'preview-image'">
    @if (
      [".mp4", ".mov", ".webm", ".mkv", "mp4", "mov", "webm", "mkv"].includes(
        mediaExtension
      )
    ) {
      <video
        controls
        muted
        class="chat-media"
        (load)="hideSpinner()"
        disablePictureInPicture
      >
        <source src="{{ mediaSrc }}" />
        Your browser does not support the video tag.
      </video>
    } @else if ([".mp3", "mp3"].includes(mediaExtension)) {
      <audio
        (load)="hideSpinner()"
        src="{{ mediaSrc }}"
        controls
        controlslist="play timeline volume nofullscreen nodownload noremoteplayback noplaybackrate"
      ></audio>
    } @else {
      <img
        id="imageElement"
        src="{{ mediaSrc }}"
        alt="Image Not Found"
        (load)="hideSpinner()"
        class="border border-1"
      />
    }
  </div>
  <div #zoomLevel class="zoom-level"></div>
</div>
